<nav mat-tab-nav-bar [tabPanel]="tabPanel" class="mb-3">
    <a mat-tab-link *ngFor="let tab of tabList" (click)="navigate(tab)" [active]="activeLink == tab.link">
        {{ tab.label }}
    </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
